import { Game } from './game/Game';

// Start the game
const game = new Game();

// Expose for debugging in dev mode
if (import.meta.env.DEV) {
  (window as any).game = game;
}
